import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * ProductRoute - Validates product is active before rendering ProductDetail.
 * Returns 404 if product not found. Meta/title/description are set by ProductDetail only.
 */
function ProductRoute({ children }) {
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      setIsValid(false);
      return;
    }

    const validateProduct = async () => {
      try {
        const response = await fetch(`${API_URL}/products/slug/${slug}`, { cache: 'no-store' });
        const data = await response.json();

        if (data.success && data.product) {
          setIsValid(true);
        } else {
          setIsValid(false);
        }
      } catch (error) {
        console.error('Product validation error:', error);
        setIsValid(false);
      } finally {
        setLoading(false);
      }
    };

    validateProduct();
  }, [slug]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
      }}>
        <div className="auth-spinner"></div>
      </div>
    );
  }

  if (!isValid) {
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}

export default ProductRoute;
